import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import styles from "./TextArea.module.scss";
/**
 * @deprecated use TextArea from @jti/ui instead
 */
export const DEPRECATED_TextArea = forwardRef(({ className, dataTestId = "", onChange = () => void 0, showCounter, maxLength, ...rest }, ref) => {
    const [value, setValue] = useState("");
    const handleChange = (e) => {
        if (showCounter) {
            setValue(e.target.value);
        }
        onChange(e);
    };
    return (_jsxs("div", { children: [_jsx("textarea", { ...rest, ref: ref, maxLength: maxLength, className: `${styles.textarea} ${className ? className : ""}`, onChange: handleChange, "data-testid": dataTestId || "" }), showCounter && maxLength && (_jsxs("div", { "data-testid": "textareaCounter", className: styles.counter, children: [value.length, "/", maxLength] }))] }));
});
//# sourceMappingURL=DEPRECATED_TextArea.js.map